// export const RQ_UPLOAD_DOCUMENT_API = {
//   url: 'api/v1/document/upload',
//   method: 'POST',
//   auth: true,
// };

export const RQ_UPLOAD_DOCUMENT_API = {
  url: '/api/v1/upload-file',
  method: 'POST',
  auth: true,
};

export const RQ_DOCUMENT_THUMBNAIL_API  = {
  url: 'api/v1/document/<%= id %>/thumbnail',
  method: 'GET',
  auth: true,
};

export const RQ_DOCUMENT_THUMBNAIL_UI_API  = {
  url: 'api/v1/document/<%= id %>/ui/thumbnail',
  method: 'GET',
  auth: false,
};

export const RQ_DOCUMENT_VIEW_API  = {
  url: 'api/v1/document/<%= id %>/view',
  method: 'GET',
  auth: true,
};

export const RQ_DOCUMENT_VIEW_UI_API  = {
  url: 'api/v1/document/<%= id %>/ui/view',
  method: 'GET',
  auth: false,
};

export const RQ_DOCUMENT_LOOKUP_API  = {
  url: 'api/v1/document/<%= id %>/lookup',
  method: 'GET',
  auth: true,
};

export const RQ_DOCUMENT_LOOKUP_UI_API  = {
  url: 'api/v1/document/<%= id %>/ui/lookup',
  method: 'GET',
  auth: false,
};
